<template>
    <div class="dashboard">
        <div class="content-area">
            <base-header @sidemenu="$emit('responsiveSideBar')"></base-header>
            <div class="right-panel system-logs-page">
                <div class="wrap-content">
                    <div class="filter-section row-min-space">
                        <div class="row">
                            <div class="col-xs-12 col-md-12">
                                <h2>Search Idenfo Screening Data</h2>
                            </div>
                            <div class="col-xs-12 col-md-12">
                                <div class="row">
                                    <div class="col-xs-12 col-md-12">
                                        <div class="row">
                                            <div class="col-xs-12 col-md-4">
                                                <base-search placeholder="Search" @keyword="getKeyword"></base-search>
                                            </div>
                                            <div class="col-xs-12 col-md-4">
                                                <base-search placeholder="Identity/Passport Number"
                                                    @keyword="getKeywordId"></base-search>
                                            </div>
                                            <div class="col-xs-12 col-md-4">
                                                <button class="btn btn-primary" type="submit" :class="
                                                    loading &&
                                                        showPageLoader
                                                        ? 'disabled'
                                                        : ''
                                                " @click="search">
                                                    <span class="btn-text">Search</span>
                                                    <span class="loader"></span>
                                                </button>
                                                <!-- <button class="btn btn-primary" type="submit" :class="
                                                    loading &&
                                                        showPageLoader
                                                        ? 'disabled'
                                                        : ''
                                                " @click="searchElastic">
                                                    <span class="btn-text">Search Elastic</span>
                                                    <span class="loader"></span>
                                                </button> -->
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-xs-12 col-md-12">
                            <h2>Mongo Database</h2>
                        </div>
                        <div class="col-xs-12 col-md-12">
                            <div :class="[
                            'table-section',
                            'table-min-width',
                            'system-logs-table',
                            { 'overflow-hidden': !data.length && !showPageLoader, },]">
                                <b-table :items="data" :fields="fields" no-local-sorting @sort-changed="sortingChanged">
                                    <template slot="full_name" slot-scope="data">
                                        <a href="javascript:void(0);" class="cursor-pointer"
                                            @click="selectedRecord(data.item); $bvModal.show('screening-detail-popup')">{{
                                                    data.item.name | primaryName
                                            }}</a>
                                    </template>
                                    <template slot="father" slot-scope="data">
                                        {{ data.item.name | identityFilter }}
                                    </template>
                                    <template slot="dates" slot-scope="data">
                                        {{
                                                sourceDobFormatting(
                                                    data.item.sourceDob
                                                )
                                        }}
                                    </template>
                                    <template slot="listCategory" slot-scope="data">
                                        {{ data.item.listCategory ? data.item.listCategory : 'N/A' }}
                                    </template>
                                    <template slot="country" slot-scope="data">
                                        {{ data.item.country | citizenship }}
                                    </template>
                                    <template slot="sourceReferenceId" slot-scope="data">
                                        {{ data.item.sourceReferenceId ? data.item.sourceReferenceId : 'N/A' }}
                                    </template>
                                    <template slot="sourceList" slot-scope="data">
                                        {{ data.item.sourceList ? data.item.sourceList :
                                                'N/A'
                                        }}
                                    </template>
                                </b-table>
                                <base-table-spinner v-if="!data.length && !data.showPageLoader"></base-table-spinner>
                                <!-- When record not found -->
                                <base-no-record-found v-if="!data.length && data.showPageLoader"></base-no-record-found>
                            </div>
                            <base-records path="screening-data/" type="screeningDataSearch" :query="query"
                                :reset="reset" :show-pagination="true">
                            </base-records>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-xs-12 col-md-12">
                            <h2>Elastic Search Database</h2>
                        </div>
                        <div class="col-xs-12 col-md-12">
                            <div :class="[
                            'table-section',
                            'table-min-width',
                            'system-logs-table']">
                                <template>
                                    <b-table striped hover :items="items" :fields="fields" :per-page="perPage"
                                        :current-page="currentPage">
                                        <template slot="full_name" slot-scope="data">
                                            <a href="javascript:void(0);" class="cursor-pointer"
                                                @click="selectedRecord(data.item._source); $bvModal.show('screening-detail-popup')">{{
                                                        data.item._source.name | primaryName
                                                }}</a>
                                        </template>
                                        <template slot="father" slot-scope="data">
                                            {{ data.item._source.name | identityFilter }}
                                        </template>
                                        <template slot="dates" slot-scope="data">
                                            {{
                                                    sourceDobFormatting(
                                                        data.item._source.sourceDob
                                                    )
                                            }}
                                        </template>
                                        <template slot="listCategory" slot-scope="data">
                                            {{ data.item._source.listCategory ? data.item._source.listCategory :
                                                    'N/A'
                                            }}
                                        </template>
                                        <template slot="country" slot-scope="data">
                                            {{ data.item._source.country | citizenship }}
                                        </template>
                                        <template slot="sourceReferenceId" slot-scope="data">
                                            {{ data.item._source.sourceReferenceId ?
                                                    data.item._source.sourceReferenceId : 'N/A'
                                            }}
                                        </template>
                                        <template slot="sourceList" slot-scope="data">
                                            {{ data.item._source.sourceList ? data.item._source.sourceList :
                                                    'N/A'
                                            }}
                                        </template>
                                    </b-table>
                                    <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage"
                                        aria-controls="my-table"></b-pagination>
                                </template>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <screening-detail-popup v-show="data.length > 0"></screening-detail-popup>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import screeningDetailPopup from '@/components/popups/ScreeningDetailPopup.vue'
import statusTypeIcon from '@/components/AlertType.vue'
import resource from '@/api/resource'
const screeningDataSearchApi = new resource('screening-data/elastic')

export default {
    components: {
        screeningDetailPopup,
        statusTypeIcon
    },

    /*
    |--------------------------------------------------------------------------
    | Component > props
    |--------------------------------------------------------------------------
    */

    props: {
        id: {
            required: true,
        },
    }, // End of Component > props

    /*
    |--------------------------------------------------------------------------
    | Component > data
    |--------------------------------------------------------------------------
    */
    data() {
        return {
            showPageLoader: false,
            screeningData: [],
            fields: [],
            loading: false,
            query: {
                startAt: 1,
                perPage: 10,
                sortBy: 'personEntityId',
                sortOrder: 'desc',
                keyword_name: '',
                keyword_cnic: '',
                type: 'screeningDataSearch'
            },
            reset: new Date().getTime(),

            perPage: 10,
            currentPage: 1,
            items: []
        }
    }, // End of Component > data

    /*
    |--------------------------------------------------------------------------
    | Component > computed
    |--------------------------------------------------------------------------
    */
    computed: {
        ...mapGetters([
            'data',
            'dataSegmentId',
            'showPageLoader',
            'loading',
            'profile',
        ]),
        rows() {
            return this.items.length
        }
    }, // End of Component > computed
    watch: {
        dataSegmentId(value) {
            if (value) {
            }
        },
    },
    /*
    |--------------------------------------------------------------------------
    | Component > mounted
    |--------------------------------------------------------------------------
    */
    mounted() {
        this.initializeData();
    }, // End of Component > mounted
    /*
    |--------------------------------------------------------------------------
    | Component > methods
    |--------------------------------------------------------------------------
    */
    methods: {
        async initializeData() {
            this.fields = this.profile.screeningSearch.fields;
            this.search();
        },
        getKeyword(val) {
            this.query.keyword_name = val
        }, // End of getKeyword() method
        getKeywordId(val) {
            this.query.keyword_cnic = val
        },
        sourceDobFormatting(val) {
            if (val === '' || !val) {
                return 'N/A'
            }

            return this.$moment(val, 'DD/MM/YYYY').format('MMM D, YYYY')
        },

        sortingChanged(ctx) {
            // ctx.sortBy   ==> Field key for sorting by (or null for no sorting)
            this.query.sortBy = ctx.sortBy

            // ctx.sortDesc ==> true if sorting descending, false otherwise
            this.query.sortOrder = ctx.sortDesc ? -1 : 1

            this.search()
        }, // End of sortingChanged() method
        selectedRecord(record, index) {
            record.index = index
            console.log('record ', record)
            this.$store.commit('setItem', record)
        }, // End of selectedRecord() method
        async search() {
            this.searchElastic();
            this.$store.commit('showPageLoader', true)
            this.reset = new Date().getTime()
        },
        async searchElastic() {
            console.log(this.query)
            let { data } = await screeningDataSearchApi.list({
                ...this.query
            })
            console.log(data.data);
            this.items = data.data;
        }
    },
    filters: {
        simpleReturn: function (value) {
            if (!value) return 'N/A'
            if (value === '') return 'N/A'

            return value.toString()
        },
        primaryName: function (value) {
            if (!value) return 'N/A'
            value = value.filter((v) => {
                return v.type === 'Primary Name'
            })

            return value[0].firstName
        },
        citizenship: function (value) {
            if (value) {
                let citizenship = value.filter((v) => {
                    return v.type === 'Citizenship'
                })
                if (citizenship && citizenship[0] && citizenship[0].name) {
                    return citizenship[0].name
                }
            }
            return 'N/A'
        },
        identityFilter: function (value) {
            if (!value) return 'N/A'
            value = value.filter((v) => {
                return v.type === 'Primary Name'
            })

            return value[0].lastName != '' ? value[0].lastName : 'N/A'
        },
        dateOfBirth: function (value) {
            if (!value) return 'N/A'
            let dated = value[0]
            if (
                dated.day === 'Invalid date' ||
                dated.month === 'Invalid date' ||
                dated.year === 'Invalid date'
            )
                return 'N/A'
            else return dated.day + '-' + dated.month + '-' + dated.year
        },
    },
} // End of export default
</script>
